import { render, staticRenderFns } from "./VImageTransition.vue?vue&type=template&id=012cdaa9&scoped=true&"
import script from "./VImageTransition.vue?vue&type=script&lang=js&"
export * from "./VImageTransition.vue?vue&type=script&lang=js&"
import style0 from "./VImageTransition.vue?vue&type=style&index=0&id=012cdaa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cdaa9",
  null
  
)

export default component.exports